import { render, staticRenderFns } from "./RouteView.vue?vue&type=template&id=4e1f7fc0&"
import script from "./RouteView.vue?vue&type=script&lang=ts&"
export * from "./RouteView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports